<template>
  <!-- 装货作业单详情 -->
  <div class="editSheet_content">
    <div class="dispatch_head">
      <div class="topBtns">
        <el-button style="margin-top: 10px" type="primary" @click="backTo"
          >返回</el-button
        >
      </div>
    </div>
    <el-collapse v-model="activeNames">
      <!-- 发车信息 -->
      <el-collapse-item title="发车信息" name="1">
        <DepartureInformation
          ref="refDepartureInformation"
          :loadOrderId="loadOrderId"
          :canEdit="false"
        ></DepartureInformation>
      </el-collapse-item>
      <!-- 装货明细 -->
      <el-collapse-item title="装货明细" name="2">
        <ShipmentDetails
          ref="refShipmentDetails"
          :loadOrderId="loadOrderId"
          :canEdit="false"
        ></ShipmentDetails>
      </el-collapse-item>
      <!-- 应付费用 -->
      <el-collapse-item title="应付费用" name="3">
        <FeesPayable
          ref="refFeesPayable"
          :loadOrderId="loadOrderId"
          :canEdit="true"
        ></FeesPayable>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import DepartureInformation from "./departureInformation.vue";
import ShipmentDetails from "./shipmentDetails.vue";
import FeesPayable from "./feesPayable.vue";
export default {
  components: {
    DepartureInformation,
    ShipmentDetails,
    FeesPayable,
  },
  props: {
    loadOrderId: {},
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      canEdit: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    backTo() {
      this.$BaseIndex.closeCurrentTab()
      this.$router.replace("/DispatchCar/LoadingOperationSheet");
      this.$BaseIndex.refresh()
    },
  },
};
</script>

<style lang="less" scoped>
.editSheet_content {
  padding-bottom: 50px;
  .dispatch_head {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    .topBtns {
      background-color: #fff;
      margin-top: -10px;
      // height: 50px;
    }
  }
}
</style>